import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TaskBulkRequest,
  TaskBulkResult,
  TaskBulkReassignFromUserRequest
} from '../models/task.model';

@Injectable({ providedIn: 'root' })
export class TaskBulkApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  // POST /api/tasks/bulk
  bulk(req: TaskBulkRequest): Observable<TaskBulkResult> {
    return this.http.post<TaskBulkResult>(`${this.apiUrl}/tasks/bulk`, req);
  }

  // POST /api/tasks/bulk/reassign-from-user
  reassignFromUser(req: TaskBulkReassignFromUserRequest): Observable<TaskBulkResult> {
    return this.http.post<TaskBulkResult>(`${this.apiUrl}/tasks/bulk/reassign-from-user`, req);
  }
}
